
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/home",
      function () {
        return require("private-next-pages/app/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/home"])
      });
    }
  